import { useCallback, useMemo } from 'react';

export const transformSortingOption = (sorting) => {
  if (Array.isArray(sorting) && sorting.length > 1) {
    return sorting;
  }
  const sortingOption = sorting && Array.isArray(sorting) ? sorting[0] : undefined;
  let sort = sortingOption;
  if (typeof sortingOption === 'object') {
    if (sortingOption.usdTotalPrice && sortingOption.usdTotalPrice === 'ASC') {
      sort = 'price_low_to_high';
    } else if (sortingOption.usdTotalPrice && sortingOption.usdTotalPrice === 'DESC') {
      sort = 'price_high_to_low';
    } else if (sortingOption.departureDate && sortingOption.departureDate === 'ASC') {
      sort = 'departure_date';
    } else if (sortingOption.popularity && sortingOption.popularity === 'DESC') {
      sort = 'most_popular';
    }
  }
  return sort;
};

const useSorting = ({ dispatch, value }) => {
  const onChange = useCallback(
    (event) => {
      const { options, selectedIndex } = event.target;
      dispatch({
        type: 'SORTING_CHANGE',
        payload: { value: event.target.value, label: options[selectedIndex].text }
      });
    },
    [dispatch]
  );

  const selectedOption = typeof value === 'string' ? value : 'no_sorting';

  return useMemo(
    () => ({
      selectedOption,
      value,
      onChange
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onChange, selectedOption]
  );
};

export default useSorting;
